import React, { useState } from 'react';
import { Game } from '../data/games';

type FeaturedGameImageProps = {
  game: Game;
};

function FeaturedGameImage({ game }: FeaturedGameImageProps) {
  const [useFallback, setUseFallback] = useState(false);

  return (
    <img
      src={useFallback ? game.image : game.featuredImage}
      alt={game.title}
      className="kg-game-card-img"
      onError={() => setUseFallback(true)}
    />
  );
}

export default FeaturedGameImage;
